/** Preset chip colors for organization tags. */
export const TAG_PRESET_COLORS = [
  '#BBDEFB', // light blue (default)
  '#C8E6C9', // green
  '#FFCDD2', // red
  '#FFECB3', // amber
  '#E1BEE7', // purple
  '#B2DFDB', // teal
  '#FFCCBC', // orange
  '#CFD8DC', // blue grey
  '#F8BBD0', // pink
  '#C5CAE9', // indigo
] as const;

export type TagPresetColor = (typeof TAG_PRESET_COLORS)[number];

export const TAG_DEFAULT_COLOR: TagPresetColor = '#BBDEFB';
